module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/7chap1#chap1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/8chap2#chap2"
    }
  }, [_vm._v("Part I THE SURGEONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/9chap3#chap3"
    }
  }, [_vm._v("Chapter 1 The Birth of a Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/10chap4#chap4"
    }
  }, [_vm._v("Chapter 2 The Heart of the Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/11chap5#chap5"
    }
  }, [_vm._v("Chapter 3 The Crusader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/12chap6#chap6"
    }
  }, [_vm._v("Chapter 4 The Making of a Miracle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/13chap7#chap7"
    }
  }, [_vm._v("Chapter 5 The Saga Continues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14chap8#chap8"
    }
  }, [_vm._v("Part II THE DONOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/15chap9#chap9"
    }
  }, [_vm._v("Chapter 6 Richie Becker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/16chap10#chap10"
    }
  }, [_vm._v("Chapter 7 Dealing with Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/17chap11#chap11"
    }
  }, [_vm._v("Part III PITTSBURGH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/18chap12#chap12"
    }
  }, [_vm._v("Chapter 8 The Court of Last Resort")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/19chap13#chap13"
    }
  }, [_vm._v("Chapter 9 Slowly Dying")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/20chap14#chap14"
    }
  }, [_vm._v("Chapter 10 Face to Face")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/21chap15#chap15"
    }
  }, [_vm._v("Chapter 11 Beyond the “God Squad”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/22chap16#chap16"
    }
  }, [_vm._v("Part IV THE WAIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/23chap17#chap17"
    }
  }, [_vm._v("Chapter 12 Hope and Despair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/24chap18#chap18"
    }
  }, [_vm._v("Chapter 13 No Matter How Long the Night, the Day Is Sure to Follow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/25chap19#chap19"
    }
  }, [_vm._v("Chapter 14 The “Patient-Pioneer”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/26chap20#chap20"
    }
  }, [_vm._v("Chapter 15 That Magic Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/27chap21#chap21"
    }
  }, [_vm._v("Chapter 16 Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/28chap22#chap22"
    }
  }, [_vm._v("Chapter 17 Is Enough Ever Enough?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/29chap23#chap23"
    }
  }, [_vm._v("Chapter 18 Return to Pittsburgh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/30chap24#chap24"
    }
  }, [_vm._v("Part V THE PROCEDURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/31chap25#chap25"
    }
  }, [_vm._v("Chapter 19 The Cult")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/32chap26#chap26"
    }
  }, [_vm._v("Chapter 20 First Cut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/33chap27#chap27"
    }
  }, [_vm._v("Chapter 21 The Procurement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/34chap28#chap28"
    }
  }, [_vm._v("Chapter 22 The Transplant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/35chap29#chap29"
    }
  }, [_vm._v("Chapter 23 Just Another Goddamn Miracle!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/36chap30#chap30"
    }
  }, [_vm._v("Part VI LIFE AFTER TRANSPLANTATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/37chap31#chap31"
    }
  }, [_vm._v("Chapter 24 The Long Road Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/38chap32#chap32"
    }
  }, [_vm._v("Chapter 25 Setbacks and Disappointments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/39chap33#chap33"
    }
  }, [_vm._v("Chapter 26 Syndrome or Disease!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/40chap34#chap34"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/41chap35#chap35"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/42page#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/43chap36#chap36"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/44about#about"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f073c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-TOC.vue
// module id = 69
// module chunks = 0